import { Component, DestroyRef, ElementRef, ViewChild, inject } from '@angular/core';
import { ServicesService } from 'src/services/services.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
  selector: 'app-editevent',
  templateUrl: './editevent.component.html',
  styleUrls: ['./editevent.component.scss'],
  standalone: false
})

export class EditeventComponent {
  message!: string;
  logofileURL!: string | ArrayBuffer | null;
  imgType: any
  logoPath: any;
  imagefileURL!: string | ArrayBuffer | null;
  imagePath: any;
  isOld2 = false;
  isOld1 = false;

  public model = {
    editorData: ''
  };

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Write Description....',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      { name: 'quote', class: 'quote' },
      { name: 'redText', class: 'redText' },
      { name: 'titleText', class: 'titleText', tag: 'h1' }
    ],
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
  };

  event_id: any
  event_data: any;
  user_id: any;
  event_name: any;
  event_type: any;
  description: any;
  address: any;
  organizer: any;
  company_pan: any;
  reg_fee: any;
  total_reg: any;
  user_mobile: any;
  user_name: any;
  user_pwd: any;
  from_date: any;
  to_date: any;
  event_logo: any;
  event_image: any;
  from_time: any;
  to_time: any;
  type: any;
  is_active: any;
  user_result: any;
  private destoryRef = inject(DestroyRef);
  selectedUser_id: any;
  event_result: any;

  constructor(
    private service: ServicesService,
    public route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private location: Location
  ) { }

  ngOnInit() {
    this.event_id = this.route.snapshot.params['event_id'];
    this.Get_Event_By_Id(this.event_id);
    this.Get_User('all');
    this.getType();
  }

  @ViewChild('input') input!: ElementRef<HTMLInputElement>;
  options: { user_mobile: string, user_id: any }[] = [];
  filteredOptions: { user_mobile: string, user_id: any }[] = [];

  filter() {
    const filterValue = this.input.nativeElement.value.toLowerCase();
    this.filteredOptions = this.options.filter(option =>
      option.user_mobile.toLowerCase().includes(filterValue)
    );
  }

  getType() {
    this.service.get_eventtype().subscribe(
      (data: any) => {
        this.event_result = data.data;
      }
    );
  }

  Get_User(user_type: string) {
    this.service.get_user(user_type).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
      (data: any) => {
        this.options = data.data.map((item: { user_mobile: string; user_id: number }) => ({
          user_mobile: item.user_mobile,
          user_id: item.user_id
        }));
        this.user_mobile = this.options.find(option => option.user_id === this.user_id)?.user_mobile || '';
      },
      error => {
        this.toastr.error('Failed to load users');
      }
    );
  }

  onUserSelectionChanged(event: MatAutocompleteSelectedEvent) {
    const selectedOption = event.option.value;
    this.selectedUser_id = selectedOption.user_id;
    this.user_mobile = selectedOption.user_mobile;
  }

  previewplogo(files: any) {
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.logofileURL = reader.result;
      this.imgType = 'event_logo';
      this.service.uploadimage(this.logofileURL, this.imgType).subscribe((data: any) => {
        this.logoPath = data['image_name'];
        this.isOld2 = false;
      });

    };
  }


  previewpimage(files: any) {
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.imgType = 'event_image';
      this.service.uploadimage(this.imagefileURL, this.imgType).subscribe((data: any) => {
        this.imagePath = data['image_name'];
        console.log(this.imagePath);

        this.isOld1 = false;
      });
    };
  }

  Get_Event_By_Id(event_id: any) {
    this.service.get_event_by_id(event_id).subscribe(
      (data: any) => {
        this.event_data = data.data;
        this.event_id = this.event_data[0].event_id;
        this.user_id = this.event_data[0].user_id;
        this.event_name = this.event_data[0].event_name;
        this.event_type = this.event_data[0].event_type;
        this.description = this.event_data[0].description;
        this.address = this.event_data[0].address;
        this.organizer = this.event_data[0].organizer;
        this.company_pan = this.event_data[0].company_pan;
        this.reg_fee = this.event_data[0].reg_fee;
        this.total_reg = this.event_data[0].total_reg;
        this.from_date = this.event_data[0].from_date;
        this.to_date = this.event_data[0].to_date;
        this.event_logo = this.event_data[0].event_logo;
        this.event_image = this.event_data[0].event_image;
        this.from_time = this.event_data[0].from_time;
        this.to_time = this.event_data[0].to_time;
        this.type = this.event_data[0].type;
        this.is_active = this.event_data[0].is_active = 1 ? '1' : '0';
        this.isOld1 = true;
        this.isOld2 = true;


      });
  }

  Update_Event() {
    const Event_Data = {
      event_id: this.event_id,
      user_id: this.selectedUser_id ? this.selectedUser_id : this.user_id,
      event_name: this.event_name,
      event_type: this.event_type,
      description: this.description,
      address: this.address,
      organizer: this.organizer,
      company_pan: this.company_pan,
      reg_fee: this.reg_fee,
      total_reg: this.total_reg,
      from_date: this.from_date,
      to_date: this.to_date,
      event_logo: this.isOld2 ? this.event_logo : this.logoPath,
      event_image: this.isOld1 ? this.event_image : this.imagePath,
      from_time: this.from_time,
      to_time: this.to_time,
      type: this.type,
      is_active: this.is_active,
    }
    this.service.edit_update(Event_Data).subscribe(
      (data: any) => {
        this.toastr.success("Event Updated Succesfully");
        this.router.navigate(['/admin/Events']);
      });
  }

  Cancel() {
    this.location.back();
  }

}
